import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import useInventoryEnabled from '../businesses/useInventoryEnabled';
import { getCatalog } from '../../services/catalog';

/** Loaded once per session; filtering and search run on the cached result. */
function useCatalog(enabled = true) {
  const { user } = useUser();
  const inventoryEnabled = useInventoryEnabled();
  const businessId = user?.business?.id;

  return useQuery({
    queryKey: ['catalog', businessId],
    queryFn: () => getCatalog(businessId!),
    enabled: enabled && inventoryEnabled && !!businessId,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export default useCatalog;
